import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppInsightsService } from './app-insights.service';

@Injectable({
    providedIn: 'root'
})
export class FCSFormService {
  constructor(public http: HttpClient, private appInsightsService: AppInsightsService) { }

  saveForm(data) {
    // Log form data to App Insights before sending
    this.appInsightsService.logTrace('Form Data Submitted to Backend', {
      caseNumber: data.caseNumber,
      signature: data.Signature,
      printName: data.PrintName
    });

    return this.http.post(window.location.href + "IntakeForm", data );
  }
}
